import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { RapidTestProduct, RapidTestUpdateResult, VaccinationUpdateResult } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/covid-product`;

export const updateRapidTestProducts = (source: CancelTokenSource)
    : Promise<RapidTestUpdateResult> => {

  return axios
      .post(`${apiUri}/rapid-test/update`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getRapidTestCodes = (source: CancelTokenSource)
    : Promise<RapidTestProduct[]> => {

  return axios
      .get(`${apiUri}/rapid-test/code`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const updateVaccinations = (source: CancelTokenSource)
    : Promise<VaccinationUpdateResult> => {

  return axios
      .post(`${apiUri}/vaccination/update`, {cancelToken: source.token})
      .then((response) => response.data);
};
